import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import PHONE_TYPE_SELECT_OPTIONS from "constants/phoneTypeSelectOptions";

interface PhoneTypeFieldProps {
    register: UseFormRegisterReturn;
    error?: string;
    value?: string;
    disabled?: boolean;
    width?: string;
    id?: string;
}

const PhoneTypeField = ({ register, error, value, disabled = false, width = "flex-1 min-w-0", id }: PhoneTypeFieldProps) => {
    return (
        <div className={`form-control ${width}`}>
            <label className="label h-7" htmlFor={id}>
                <span className="text-base-content">Type</span>
            </label>
            <select
                {...register}
                id={id}
                value={value}
                className={`select select-bordered bg-base-100 h-9 min-h-9 text-sm ${
                    disabled ? "opacity-50 cursor-not-allowed" : ""
                } ${error ? "select-error" : ""} ${!value ? "text-gray-400" : ""}`}
                disabled={disabled}
            >
                <option value="" disabled>
                    Select
                </option>
                {PHONE_TYPE_SELECT_OPTIONS.map((type) => (
                    <option key={type.value} value={type.value} className="text-base-content">
                        {type.label}
                    </option>
                ))}
            </select>
            {error && <p className="text-error text-xs mt-1">{error}</p>}
        </div>
    );
};

export default PhoneTypeField;
